import * as signalR from '@microsoft/signalr';
import { isViewAsBuyerActive } from './viewAsBuyer';

export const SendWebsocketMessage = async (
    connection: signalR.HubConnection,
    message: string,
    payload?: any
) => {
    if (isViewAsBuyerActive()) {
        return;
    }
    if (connection?.state !== signalR.HubConnectionState.Connected) {
        return;
    }
    try {
        if (payload) {
            await connection.send(message, payload);
        } else {
            await connection.send(message);
        }
    } catch {
        // The transport can close between the state check and the send;
        // treat that race like the not-connected case above. Everything
        // routed through this helper is a housekeeping signal that the
        // reconnect logic replays, so a dropped one self-heals.
    }
};
